import { Badge, Label, Radio } from '@elladx/design-system';
import type { Rate } from '../types';
import { formatCurrency } from '../utils/currency';
import { deliveryEstimate, friendlyServiceName, rateHighlights } from '../utils/shippingServices';
interface RateSelectorProps {
    rates: Rate[];
    selectedRateId: string | null;
    onSelect: (rate: Rate) => void;
    loading?: boolean;
    disabled?: boolean;
    name?: string;
}
/**
 * FedEx rate rows for the shipment rail. Renders bare (no card wrapper); the
 * host "FedEx rates" card supplies the header.
 */
function RateSelector({ rates, selectedRateId, onSelect, loading = false, disabled = false, name = 'rate' }: RateSelectorProps) {
    if (loading) {
        return (<div className="rate-list" aria-label="Loading rates">
        <div className="skeleton" style={{ height: '44px' }}/>
        <div className="skeleton" style={{ height: '44px' }}/>
        <div className="skeleton" style={{ height: '44px' }}/>
      </div>);
    }
    if (rates.length === 0) {
        return null;
    }
    const highlights = rateHighlights(rates);
    return (<div className="rate-list" role="radiogroup" aria-label="FedEx rates" aria-disabled={disabled}>
      {rates.map((rate) => {
            const selected = selectedRateId === rate.id;
            return (<Label key={rate.id} className={`rate-row ${selected ? "selected" : ""}`} style={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.75 : 1 }}>
            <Radio name={name} value={rate.id} checked={selected} onChange={() => onSelect(rate)} disabled={disabled}/>

            <span className="rate-info">
              <span className="rate-service">
                {friendlyServiceName(rate)}
              </span>
              <span className="rate-eta">{deliveryEstimate(rate)}</span>
              <span className="shipping-rate-badges">
                {highlights.cheapest.has(rate.id) && <Badge>Lowest price</Badge>}
                {highlights.fastest.has(rate.id) && <Badge>Fastest</Badge>}
              </span>
            </span>
            <span className="rate-price">{formatCurrency(rate.rate, rate.currency)}</span>
          </Label>);
        })}
    </div>);
}
export default RateSelector;
